<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
        </div>
        <div class="widget-content">
          <div class="d-flex justify-content-between align-items-center">
            <h2>Lista nieobecnosci: {{ months[selectedMonth] }} {{ selectedYear }}</h2>
            <div><span v-if="hasPermission('canAddL4')" class="mb-2">
                <label class="switch s-icons s-outline s-outline-success mb-3 h-100">
                  <input type="checkbox" v-model="showTable" :true-value="1" :false-value="0">
                  <span class="slider round"></span>
                </label> Pokaż tabelę kartek</span>
              <button class="btn btn-sm btn-outline-secondary ms-2 me-2 mb-2" @click="prevMonth">← {{ prevMonthName
                }}</button>
              <button class="btn btn-sm btn-outline-secondary  mb-2" @click="nextMonth">{{ nextMonthName }} →</button>
            </div>
          </div>

          <div v-if="pendingRequests.length !== 0"
            class="col-12 row d-flex justify-content-between align-items-stretch ms-0 mb-4">
            <div class="card h-100 w-100 shadow-sm">
              <div class="card-body d-flex flex-column align-items-center justify-content-start">
                <h5 class="card-title w-100">Wnioski do zatwierdzenia</h5>
                <div class="w-100 mb-3 overflow-auto">
                  <table class="table table-bordered table-sm table-hover text-center">
                    <thead class="table-light">
                      <tr>
                        <th>Pracownik</th>
                        <th>Dział</th>
                        <th>Stanowisko</th>
                        <th style="min-width:100px;">Od</th>
                        <th style="min-width:100px;">Do</th>
                        <th>Dni wolne</th>
                        <th>Rodzaj wniosku</th>
                        <th style="min-width:100px;">Utworzono</th>
                        <th>Opcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="wniosek in pendingRequests" :key="wniosek.id">
                        <td>{{ wniosek.first_name }} {{ wniosek.last_name }}</td>
                        <td>{{ wniosek.department_name }}</td>
                        <td>{{ wniosek.position }}</td>
                        <td style="min-width:100px;">{{ wniosek.start }}</td>
                        <td style="min-width:100px;">{{ wniosek.end }}</td>
                        <td>{{ wniosek.wolnedni }}</td>
                        <td>{{ wniosek.opis }}</td>
                        <td style="min-width:100px;">
  <div>{{ formatDateToYMD(wniosek.created_at) }}</div>
  <small v-if="wniosek.created_by_name" class="text-muted">
    ({{ wniosek.created_by_name }})
  </small>
</td>
                        <td>
                          <button v-if="hasPermission('canAcceptUrlop')" type="button"
                            class="btn btn-outline-success btn-sm ms-2 mt-1 mb-1"
                            @click="accept(wniosek.id)">Zatwierdź</button>
                          <button v-if="hasPermission('canRejectUrlop')" type="button"
                            class="btn btn-outline-danger btn-sm ms-2 mt-1 mb-1"
                            @click="reject(wniosek.id)">Odrzuć</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>



          <div v-if="przepustkiRequests.length !== 0" class="col-12 row d-flex align-items-stretch">
            <div class="col-md-12 mb-4">
              <div class="card h-100 shadow-sm">
                <div class="card-body d-flex flex-column align-items-center justify-content-start">
                  <h5 class="card-title w-100">Przepustki do zatwierdzenia</h5>
                  <div class="w-100 mb-3 overflow-auto">
                    <table class="table table-bordered table-sm table-hover text-center">
                      <thead class="table-light">
                        <tr>
                          <th>Pracownik</th>
                          <th style="min-width:120px;">Data wyjścia</th>
                          <th>Godzina wyjścia</th>
                          <th>Liczba godzin</th>
                          <th>Podpisana</th>
                          <th style="min-width:100px;">Utworzono</th>
                          <th>Opcje</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="przepustka in przepustkiRequests" :key="przepustka.id">
                          <td>{{ przepustka.first_name }} {{ przepustka.last_name }}</td>
                          <td style="min-width:120px;">{{ przepustka.data_wyjscia }}</td>
                          <td>{{ przepustka.od_godziny }}</td>
                          <td>{{ przepustka.liczba_godzin }} {{ getPrzepustkaTyp(przepustka.typ) }}</td>
                          <td>
                            <div v-if="przepustka.podpis_exists">TAK</div>
                            <div v-else>NIE</div>
                          </td>
                          <td style="min-width:100px;">
  <div>{{ formatDateToYMD(przepustka.created_at) }}</div>
  <small v-if="przepustka.created_by_name" class="text-muted">
    ({{ przepustka.created_by_name }})
  </small>
</td>
                          <td>
                            <button v-if="hasPermission('canAcceptUrlop')" type="button"
                              class="btn btn-outline-success btn-sm ms-2 mt-1 mb-1"
                              @click="acceptPrzepustka(przepustka.id)">Zatwierdź</button>
                            <button v-if="hasPermission('canRejectUrlop')" type="button"
                              class="btn btn-outline-danger btn-sm ms-2 mt-1 mb-1"
                              @click="rejectPrzepustka(przepustka.id)">Odrzuć</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="pendingDelegacjaRequests.length !== 0"
            class="col-12 row d-flex justify-content-between align-items-stretch ms-0 mb-4">
            <div class="card h-100 w-100 shadow-sm">
              <div class="card-body d-flex flex-column align-items-center justify-content-start">
                <h5 class="card-title w-100">Delegacje</h5>
                <div class="w-100 mb-3 overflow-auto">
                  <table class="table table-bordered table-sm table-hover text-center">
                    <thead class="table-light">
                      <tr>
                        <th>Pracownik</th>
                        <th>Dział</th>
                        <th>Stanowisko</th>
                        <th style="min-width:100px;">Od</th>
                        <th style="min-width:100px;">Do</th>
                        <th>Ile dni</th>
                        <th>Informacja o delegacji</th>
                        <th style="min-width:100px;">Utworzono</th>
                        <th>Opcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="wniosekDelegacja in pendingDelegacjaRequests" :key="wniosekDelegacja.id">
                        <td>{{ wniosekDelegacja.first_name }} {{ wniosekDelegacja.last_name }}</td>
                        <td>{{ wniosekDelegacja.department_name }}</td>
                        <td>{{ wniosekDelegacja.position }}</td>
                        <td style="min-width:100px; max-width:200px;">{{ wniosekDelegacja.start }}</td>
                        <td style="min-width:100px;">{{ wniosekDelegacja.end }}</td>
                        <td>{{ wniosekDelegacja.wolnedni }}</td>
                        <td><span v-html="wniosekDelegacja.opis"></span></td>
						<td style="min-width:100px;">
						  <div>{{ formatDateToYMD(wniosekDelegacja.created_at) }}</div>
						  <small v-if="wniosekDelegacja.created_by_name" class="text-muted">
							({{ wniosekDelegacja.created_by_name }})
						  </small>
						</td>
                        <td>
                          <button type="button" class="btn btn-success btn-sm ms-2 mt-1 mb-1"
                            @click="acceptDelegacja(wniosekDelegacja.id)">Delegacja wypisana</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showTable" class="col-12 row d-flex justify-content-between align-items-stretch ms-0 mb-3">
            <div class="card h-100 w-100 shadow-sm">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <h5 class="card-title w-100">Brak kartki</h5>
                </div>
                <div class="w-100 mb-3 overflow-auto">
                  <table class="table table-bordered table-sm table-hover text-center">
                    <thead class="table-light">
                      <tr>
                        <th>Pracownik</th>
                        <th>Dział</th>
                        <th style="min-width:100px;">Od</th>
                        <th style="min-width:100px;">Do</th>
                        <th>Dni wolne</th>
                        <th>Rodzaj wniosku</th>
                        <th style="min-width:100px;">Utworzono</th>
                        <th>Opcje</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="wniosekBK in brakKartki" :key="wniosekBK.id">
                        <td v-if="hasPermission('canViewWorkersDane')" class="text-start text-blue">
                          <Link :href="route('kadry.urlopy.show.user', { user_id: wniosekBK.user_id })">{{
                          wniosekBK.first_name }} {{ wniosekBK.last_name }}</Link>
                        </td>
						<td v-else class="text-start">{{ wniosekBK.first_name }} {{ wniosekBK.last_name }}</td>
                        <td class="text-blue">
                          <Link :href="route('kadry.urlopy.show.user', { user_id: wniosekBK.user_id })">{{
                          wniosekBK.department_name }}</Link>
                        </td>
                        <td class="text-blue"  style="min-width:100px;">
                          <Link :href="route('kadry.urlopy.show.user', { user_id: wniosekBK.user_id })">{{
                          wniosekBK.start }}</Link>
                        </td>
                        <td class="text-blue" style="min-width:100px;">
                          <Link :href="route('kadry.urlopy.show.user', { user_id: wniosekBK.user_id })">{{ wniosekBK.end
                          }}</Link>
                        </td>
                        <td class="text-blue">
                          <Link :href="route('kadry.urlopy.show.user', { user_id: wniosekBK.user_id })">{{
                          wniosekBK.wolnedni }}</Link>
                        </td>
                        <td class="text-blue">
                          <Link :href="route('kadry.urlopy.show.user', { user_id: wniosekBK.user_id })"><span
                            v-html="wniosekBK.opis"></span></Link>
                        </td>
                        <td class="text-blue" style="min-width:100px;">
                          <Link :href="route('kadry.urlopy.show.user', { user_id: wniosekBK.user_id })">{{
                            formatDateToYMD(wniosekBK.created_at) }}</Link>
                        </td>
                        <td>
                          <button type="button" class="btn btn-primary btn-sm ms-2 mt-1 mb-1"
                            @click="acceptkartka(wniosekBK.id)">Potwierdź dostarczenie</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3">
            <div class="col-auto d-flex align-items-center me-3">
              <select v-model="selectedDepartament" class="form-select form-sm mb-2" style="width: 360px;"
                @change="changeDepartament">
                <option value="0">WSZYSTKIE DZIAŁY</option>
                <option v-for="(department, depId) in departaments" :key="depId" :value="department.id">{{
                  department.name }}</option>
                <option value="-1">POZOSTALI PRACOWNICY</option>
              </select>
            </div>

            <div class="col-auto d-flex align-items-center me-3">
              <select v-model="selectedMonth" class="form-select form-sm mb-2" style="width: 140px;" @change="loadData">
                <option v-for="(month, index) in months" :key="index" :value="index">{{ month }}</option>
              </select>
            </div>

            <div class="col-auto d-flex align-items-center">
              <select v-model="selectedYear" class="form-select form-sm mb-2" style="width: 140px;" @change="loadData">
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>
            <div class="col-auto d-flex align-items-center gap-2 mb-2">
              <a :href="route('kadry.urlopy.viewPdf') + '?id=' + selectedDepartament + '&year=' + selectedYear + '&month=' + (selectedMonth + 1)"
                class="btn btn-outline-info btn-sm equal-width-btn" rel="noopener noreferrer" target="_blank">
                <i class="bi bi-file-earmark-pdf"></i>&nbsp;Zestawienie w PDF
              </a>

              <div class="d-flex align-items-center">
                <label class="switch s-icons s-outline s-outline-success mb-0">
                  <input type="checkbox" v-model="lokalnySelPDF" :true-value="1" :false-value="0" @change="changePDF()">
                  <span class="slider round"></span>
                </label>
                <span class="ms-2">Wydruk poziomy</span>
              </div>
            </div>
          </div>

          <div class="rooms-container w-100 overflow-auto"
            style="gap: 1rem; white-space: nowrap; padding-bottom: 0.5rem;">
            <div class="table-responsive w-100">
              <div class="calendar-legend mt-1 mb-3 d-flex justify-content-center gap-4">
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: orange; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Wniosek</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: red; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Nieobecność</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: blue; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Delegacja</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: yellow; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Przepustka</span>
                </div>
                <div class="legend-item d-flex align-items-center">
                  <div
                    style="width: 20px; height: 20px; background-color: #eee3e3; border: 1px solid #000; margin-right: 6px;">
                  </div>
                  <span>Święta</span>
                </div>
              </div>
              <table class="table table-bordered table-hover text-center w-100">
                <thead>
                  <tr>
                    <th class="border p-1 bg-gray-100 text-start" style="min-width: 100px;"></th>
                    <th v-for="day in daysInMonth" :key="day" class="border p-1"
                      :class="[isToday(day) ? 'bg-Lightblue font-bold' : (isSunday(day) || isSaturday(day)) ? 'bg-gray-100 text-gray' : 'bg-gray-100', isHoliday(getDateString(day)) ? 'bg-holiday text-gray' : '']">
                      {{ day }}<br>{{ dzientygodnia(day) }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="employee in localUsers" :key="employee.id">
                    <td class="border p-1 text-start" style="min-width: 150px;">
                      <div class="d-flex justify-content-between align-items-center">
					  <span v-if="hasPermission('canViewWorkersDane')">
                        <a :href="route('kadry.urlopy.show.user', employee.id)"
                          class="text-blue hover:underline cursor-pointer"><strong>{{ employee.name }}{{
                            employee.umowa_do }}</strong></a></span>
                        <span v-else>
						<strong>{{ employee.name }}{{
                            employee.umowa_do }}</strong></span>							
							
                        <span v-if="!employee.hasUserData" class="alert alert-danger alert-xs  mt-1 ms-2"
                          style="padding: 2px 8px; font-size: 0.75rem; line-height: 1.1;">Brak danych urlopowych!</span>
                        <span v-if="employee.brakWymaganegoUrlopu" class="text-warning ms-1"
                          title="Nie wybrał wymaganego urlopu 14 dni!">⚠️</span>
                      </div>
                    </td>
                    <td v-for="day in daysInMonth" :key="employee.id + '-' + day" :class="[
                      'border p-1 text-center',
                      getStatusClass(employee, day),
                      isHoliday(getDateString(day)) ? 'bg-holiday text-gray' : '',
                      (isSunday(day) || isSaturday(day)) ? 'bg-gray-50 text-gray' : '',
                      // status istnieje i nie jest bg-p → klikalne, tekst biały
                      (!isSunday(day) && !isSaturday(day) && getStatusClass(employee, day) !== '' && getStatusClass(employee, day) !== 'bg-p') ? 'cursor-pointer text-white' : '',
                      // status bg-p → tekst czarny, brak kursora
                      getStatusClass(employee, day) === 'bg-p' ? 'text-black cursor-default' : ''
                    ]" @click="(!isSunday(day) && !isSaturday(day) && getStatusClass(employee, day) !== '' && getStatusClass(employee, day) !== 'bg-p') ? openModal(day, employee) : null">
                      {{ day }}
                    </td>

                    <!--
				<td v-for="day in daysInMonth" :key="employee.id + '-' + day" :class="['border p-1 text-center', getStatusClass(employee, day), isHoliday(getDateString(day)) ? 'bg-holiday text-gray' : '', (isSunday(day) || isSaturday(day)) ? 'bg-gray-50 text-gray' : '', (!isSunday(day) && !isSaturday(day) && getStatusClass(employee, day) !== '') ? 'cursor-pointer text-white' : '']" @click="!isSunday(day) && !isSaturday(day) && getStatusClass(employee, day) !== '' ? openModal(day, employee) : null">{{ day }}</td>
			  -->

                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="isModalOpen" class="modal fade show" tabindex="-1" style="display: block;">
            <div class="modal-dialog modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Informacje o wniosku</h5>
                  <button type="button" class="btn-close" @click="closeModal"></button>
                </div>
                <div class="modal-body">
                  <div v-if="selectedAbsence && selectedAbsence.raw_typ_urlopu !== 100">
                    <p><strong>Dzień:</strong> {{ selectedday }}.{{ selectedMonth + 1 }}.{{ selectedYear }}</p>
                    <p><strong>Pracownik:</strong> {{ pracownik_name }}</p>
                    <p><strong>Dni wolne:</strong> {{ (Number(tenRok) || 0) + (Number(poprzedniRok) || 0) }} (ten rok:
                      {{ tenRok }}, poprzedni rok: {{ poprzedniRok }})</p>
                    <p><strong>Wykorzystane dni wolne:</strong> {{ wykorzystaneDniWolne }}</p>
                    <p><strong>Pozostało dni wolnych:</strong> {{ (Number(tenRok) || 0) + (Number(poprzedniRok) || 0) -
                      (wykorzystaneDniWolne || 0) }}</p>
                  </div>
                  <div v-if="selectedAbsence">
                    <p v-if="selectedAbsence.raw_typ_urlopu !== 100"><strong>Rodzaj wniosku:</strong><br></p>
                    <p><span v-html="selectedAbsence.opis"></span></p>
                    <ejs-daterangepicker placeholder="Wybierz daty" :format="'dd/MM/yyyy'" :value="dateRange"
                      :firstDayOfWeek="1" :weekNumber="true" @change="onDateRangeChange" />
                    <div v-if="selectedAbsence.raw_typ_urlopu === 100" class="mb-3 mt-2">
                      <label class="form-label"><strong>Osoby uczestniczące:</strong></label>
                      <multiselect v-model="form.delegacjaPracownicy" :options="pracownicy" :multiple="true"
                        placeholder="Wybierz pracowników" label="name" track-by="id" />
                      <h5 class="card-title mt-3">Pliki</h5>
                      <div class="row">
                        <ul class="list-group ps-3 me-3 mt-3 mb-3">
                          <li
                            class="list-group-item d-flex align-items-center justify-content-between flex-wrap fw-bold bg-light"
                            v-if="localFiles.length > 0">
                            <div class="col-12 col-sm-6 col-md-5 text-truncate">Nazwa pliku</div>
                            <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                            <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">Opcje</div>
                          </li>

                          <li v-if="isLoadingFiles" class="list-group-item border-0">
                            <div
                              class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                              Ładowanie...</div>
                          </li>

                          <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else
                            v-for="file in localFiles" :key="file.id">
                            <div class="col-12 col-sm-6 col-md-5 text-truncate" :title="file.name">{{ file.name }}</div>
                            <div class="col-12 col-sm-4 col-md-4 text-muted small"><i>{{ file.created_at }}</i></div>
                            <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                              <div class="d-flex justify-content-end flex-wrap gap-1">
                                <a class="btn btn-sm btn-outline-info" style="width:80px;"
                                  :href="route('delegacje.download-file', [selectedAbsence.delegacja_id, file.name])"
                                  download><i class="bi bi-download me-1"></i>Pobierz</a>
                                <button class="btn btn-sm btn-outline-danger" style="width:80px;"
                                  @click="deleteFile(file)" type="button"><i class="bi bi-trash me-1"></i>Usuń</button>
                              </div>
                            </div>
                          </li>

                          <li class="list-group-item" v-if="localFiles.length <= 0 && !isLoadingFiles">
                            <i>Brak plików</i>
                          </li>
                        </ul>
                      </div>

                      <form @submit.prevent="submitForm">
                        <div class="row gap-3">
                          <div class="col-12">
                            <label for="attachments">Dodaj pliki:</label>
                            <div v-if="isLoading" class="mt-3">
                              <div class="progress" style="height: 8px;">
                                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                                  :style="{ width: uploadProgress + '%' }"></div>
                              </div>
                              <small class="text-muted">{{ uploadProgress }}%</small>
                            </div>
                            <input type="file" id="attachments" multiple @change="handleFileUpload"
                              class="form-control form-control-sm" ref="fileInput" />
                            <div v-if="form.attachments.length">
                              <p class="mt-2">Załączone pliki:</p>
                              <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                                  v-for="(file, index) in form.attachments" :key="index">
                                  <span class="text-truncate" :title="file.name">{{ file.name }}</span>
                                  <button type="button" class="btn btn-sm btn-danger ms-2 mt-1 mt-sm-0"
                                    @click="removeFile(index)">Usuń</button>
                                </li>
                              </ul>
                            </div>
                            <div v-if="form.attachments.length">
                              <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading">{{ isLoading ?
                                'Wysyłanie...' : 'Dodaj pliki' }}</button>
                            </div>
                          </div>
                        </div>
                      </form>

                    </div>
                    <div v-if="selectedAbsence.raw_typ_urlopu !== 100" class="mb-3 mt-2">
                      <label class="form-label"><strong>Status urlopu:</strong></label>
                      <select class="form-select" v-model="selectedAbsence.status">
                        <option disabled value="">Wybierz</option>
                        <option v-if="hasPermission('canAcceptUrlop')" :value="1">Zatwierdzony</option>
                        <option v-if="hasPermission('canRejectUrlop')" :value="2">Odrzucony</option>
                        <option v-if="hasPermission('canDelUrlop')" :value="999">🗑️ Usuń wniosek</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                  <button
                    v-if="selectedAbsence && selectedAbsence.raw_typ_urlopu !== 100 && hasPermission('canEditUrlop')"
                    type="button" class="btn btn-primary" @click="saveReservation">Zapisz</button>
                  <button
                    v-if="selectedAbsence && selectedAbsence.raw_typ_urlopu == 100 && hasPermission('canEditUrlop')"
                    type="button" class="btn btn-primary" @click="saveReservation2">Zapisz</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { ref, computed, onMounted } from 'vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import { DateRangePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";
import axios from 'axios'

const { hasPermission } = usePermission();

export default {
  props: {
    users: Array,
    pracownicy: Array,
    departaments: Array,
    departamentId: Number,
    SelPDF: Number,
  },
  components: { AppLayout, 'ejs-daterangepicker': DateRangePickerComponent, Multiselect, hasPermission },

  data() {
    const today = new Date()
    return {
      form: {
        delegacjaPracownicy: [],
        lokalizacja: '',
        celDelegacji: '',
        attachments: []
      },
      localFiles: [],
      isLoadingFiles: false,
      isLoading: false,
      uploadProgress: 0,
      localUsers: this.users.map(u => ({ ...u })),
      isModalOpen: false,
      dateRange: null,
      selectedOption: '',
      selectedAbsence: null,
      selectedMonth: today.getMonth(),
      selectedYear: today.getFullYear(),
      selectedDepartament: this.departamentId ?? 1,
      months: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
      years: Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - 5 + i),
      employees: [],
      typyUrlopow: Array,
      opcjeUrlopow: Object,
      newUrlop: {
        typ_id: '',
        status: 1, // 1, domyślnie zatwierdzony
        newDateRange: [],
        pracownik_id: null,
      },
      urlopy: Array,
      przepustkiRequests: [],
      pendingRequests: [],
      pendingDelegacjaRequests: [],
      brakKartki: [],
      wykorzystaneDniWolne: 0,
      showTable: 0, // domyślnie ukryta
      hasPermission,
      lokalnySelPDF: this.SelPDF,

    }
  },
  computed: {
    daysInMonth() {
      const lastDay = new Date(this.selectedYear, this.selectedMonth + 1, 0).getDate()
      return Array.from({ length: lastDay }, (_, i) => i + 1)
    },
    prevMonthName() {
      return this.months[(this.selectedMonth + 11) % 12];
    },
    nextMonthName() {
      return this.months[(this.selectedMonth + 1) % 12];
    },


  },
  watch: {
    selectedAbsence(newVal) {
      if (newVal?.raw_typ_urlopu === 100 && this.pracownicy.length > 0) {
        this.form.delegacjaPracownicy = this.pracownicy.filter(prac =>
          newVal.delegowani?.some(d => d.id === prac.id)
        );
      } else {
        this.form.delegacjaPracownicy = [];
      }

      if (newVal) {
        this.dateRange = [new Date(newVal.start), new Date(newVal.end)];
      } else {
        this.dateRange = null;
      }
    },

    selectedMonth() {
      this.loadData();
    },

    selectedYear() {
      this.loadData();
    }
  },


  methods: {
    async deleteFile(file) {
      let self = this;

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pliku',
        html: 'Czy na pewno chcesz usunąć ten plik?',
        showDenyButton: true,
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            // tutaj przekazujemy oba parametry: delegacja_id i attachment_id
            const response = await axios.delete(route('delegacje.file.delete', {
              id: self.selectedAbsence.delegacja_id,      // delegacja_id
              attachment: file.id               // attachment_id
            }));

            if (response.data.icon === 'success') {
              self.showToast('success', 'Usunięto plik', 'Plik został pomyślnie usunięty.');
              await this.getAttachments(self.selectedAbsence.delegacja_id);
            } else {
              self.showToast('error', response.data.title, response.data.message);
            }

          } catch (error) {
            console.error("Błąd usuwania pliku:", error);
            self.showToast('error', 'Błąd', 'Nie udało się usunąć pliku.');
          }
        }
      });
    },

    async submitForm() {
      if (!this.selectedAbsence) return;

      const formData = new FormData();
      this.form.attachments.forEach(file => {
        formData.append('attachments[]', file);
      });

      // dodajemy delegacja_id
      formData.append('delegacja_id', this.selectedAbsence.delegacja_id);

      this.isLoading = true;
      try {
        const response = await axios.post(route('urlopy.upload.delegacjafiles', this.selectedAbsence.delegacja_id), formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          }
        });

        // po wysłaniu odświeżamy listę plików
        await this.getAttachments(this.selectedAbsence.delegacja_id);
        this.form.attachments = [];
        this.uploadProgress = 0;

      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async getAttachments(id) {
      this.isLoadingFiles = true;
      try {
        const response = await axios.post(route('urlopy.get.delegacjafiles', id));
        this.localFiles = response.data.attachments ?? [];
      } catch (error) {
        console.error(error);
        this.localFiles = [];
      } finally {
        this.isLoadingFiles = false;
      }
    },

    handleFileUpload(event) {
      this.uploadError = null;
      const files = Array.from(event.target.files);

      const maxSize = 100 * 1024 * 1024; // 100 MB
      const validFiles = [];

      for (let file of files) {
        if (file.size > maxSize) {
          this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
        } else if (file.size === 0) {
          this.uploadError = `Plik "${file.name}" jest pusty.`;
        } else {
          validFiles.push(file);
        }
      }

      if (validFiles.length > 0) {
        this.form.attachments.push(...validFiles);
      }

      this.$refs.fileInput.value = "";
    },

    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },

    async acceptPrzepustka(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Zatwierdzenie przepustki',
        html: 'Czy na pewno chcesz zatwierdzić wybraną przepustkę?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put(route('urlopy.accept_przepustka', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Przepustka została zatwierdzona',
              });
              this.loadData();
              this.fetchPendingRequests();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się zatwierdzić przepustki',
                text: error.response?.data?.message || 'Wystąpił błąd podczas zatwierdzania przepustki',
              });
            });
        }
      });
    },

    async rejectPrzepustka(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Odrzucenie przepustki',
        html: 'Czy na pewno chcesz odrzucić wybraną przepustkę?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(route('urlopy.odrzuc_przepustka', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Przepustka została odrzucona',
              });
              this.loadData();
              this.fetchPendingRequests();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się odrzucić przepustki',
                text: error.response?.data?.message || 'Wystąpił błąd podczas odrzucenia przepustki',
              });
            });
        }
      });
    },

    async acceptDelegacja(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Potwierdzenie wypisania delegacji',
        html: 'Czy na pewno chcesz potwierdzić wypisanie delegacji?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put(route('urlopy.wypisana_delegacja', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Wypisanie delegacji zostało potwierdzone',
              });
              this.loadData();
              this.fetchPendingRequests();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się potwierdzić wypisania delegacji',
                text: error.response?.data?.message || 'Wystąpił błąd podczas potwierdzania wypisania delegacji',
              });
            });
        }
      });
    },

    async changePDF() {
      axios.put(route('kadry.change.pdf'), {
        SelPDF: this.lokalnySelPDF,
        SelID: 1
      })
        .then(response => console.log(response.data))
        .catch(error => console.error(error));
    },

    toggleTable() {
      this.showTable = !this.showTable;
    },

    async acceptkartka(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Potwierdzenie',
        html: 'Czy potwierdzasz dostraczenie wydruku przez pracownika?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put(route('kadry.urlopy.accept.kartka', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Potwierdzono dostarczenie wydruku do kadr.',
              });
              this.fetchBrakKartki();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Dane nie zostały zaktualizowane',
                text: error.response?.data?.message || 'Wystąpił błąd',
              });
            });
        }
      });
    },


    formatDateToYMD(datetime) {
      if (!datetime) return '';
      const date = new Date(datetime);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    formatDate(date) {
      const d = new Date(date);
      const month = '' + (d.getMonth() + 1);
      const day = '' + d.getDate();
      const year = d.getFullYear();

      return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
    },

    getEmployeeById(userId) {
      return this.localUsers?.find(u => u.id === userId);
    },

    async changeDepartament() {
      try {
        const response = await axios.get(route('kadry.get.users'), {
          params: {
            departament: this.selectedDepartament
          }
        });

        this.localUsers = response.data.users.map(u => ({ ...u }));
        this.loadData();
      } catch (error) {
        console.error('Błąd podczas pobierania pracowników:', error);
      }
    },

    async fetchPendingRequests() {
      try {
        const response = await axios.get(route('kadry.urlopy.pending'));
        this.pendingRequests = response.data.pending || [];
        this.przepustkiRequests = response.data.przepustki || [];
        this.pendingDelegacjaRequests = response.data.delegacje || [];
      } catch (error) {
        console.error('Błąd podczas pobierania wniosków oczekujących:', error);
      }
    },

    async fetchBrakKartki() {
      try {
        const response = await axios.get(route('kadry.urlopy.bk'));
        this.brakKartki = response.data.bk || [];
      } catch (error) {
        console.error('Błąd podczas pobierania wniosków bk:', error);
      }
    },



    getDateString(day) {
      return `${this.selectedYear}-${(this.selectedMonth + 1).toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
    },
    getEasterDate(year) {
      const f = Math.floor;
      const G = year % 19;
      const C = f(year / 100);
      const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
      const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
      const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
      const L = I - J;
      const month = 3 + f((L + 40) / 44);
      const day = L + 28 - 31 * f(month / 4);
      return new Date(year, month - 1, day);
    },

    getPolishHolidays(year) {
      const formatDate = (date) => {
        const d = new Date(date);
        const month = '' + (d.getMonth() + 1);
        const day = '' + d.getDate();
        const year = d.getFullYear();
        return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
      };

      const fixedHolidays = [
        `${year}-01-01`,
        `${year}-01-06`,
        `${year}-05-01`,
        `${year}-05-03`,
        `${year}-08-15`,
        `${year}-11-01`,
        `${year}-11-11`,
        `${year}-12-24`,
        `${year}-12-25`,
        `${year}-12-26`,
      ];

      const easter = this.getEasterDate(year);
      const holidays = [...fixedHolidays];
      holidays.push(formatDate(easter)); // Wielkanoc
      holidays.push(formatDate(new Date(easter.getTime() + 86400000))); // Pon. wielkanocny
      holidays.push(formatDate(new Date(easter.getTime() + 60 * 86400000))); // Boże Ciało

      return holidays;
    },

    isHoliday(dateInput) {
      if (!dateInput) return false;
      const dateStr = typeof dateInput === 'string' ? dateInput : this.formatDate(dateInput);
      const year = parseInt(dateStr.substring(0, 4));
      const holidays = this.getPolishHolidays(year);
      return holidays.includes(dateStr);
    },


    getTypeNameById(id) {
      const found = this.typyUrlopow.find(t => t.id === id);
      return found ? found.nazwa : String(id);
    },

    getOptionNameById(id) {
      const opcje = this.opcjeUrlopow?.[this.selectedTypeId] || [];

      if (!Array.isArray(opcje)) {
        console.warn('Brak opcji dla typu urlopu:', this.selectedTypeId);
        return String(id);
      }

      const opt = opcje.find(o => o.id === id);
      return opt ? opt.nazwa : String(id);
    },

    onLeaveTypeChange() {
      const selected = this.typyUrlopow.find(t => t.id === Number(this.newUrlop.id));
      this.selectedTypeId = selected ? selected.id : null;
      this.selectedOption = '';
    },
    hasOptionsForSelectedType() {
      const typ = this.typyUrlopow.find(t => t.id === this.newUrlop.typ_id);
      return typ && typ.opcje === 1 && this.opcjeUrlopow[this.newUrlop.typ_id];
    },

    selectedTypeDescription() {
      const typ = this.typyUrlopow.find(t => t.id === Number(this.selectedTypeId));
      return typ?.opis || '';
    },
    selectedOptionDescription() {
      if (!this.selectedOption || !this.opcjeUrlopow[this.selectedTypeId]) return '';
      const opcja = this.opcjeUrlopow[this.selectedTypeId].find(
        o => o.id === Number(this.selectedOption)
      );
      return opcja?.opis || '';
    },

    async saveReservation() {
      if (!this.selectedAbsence) return;

      const [od, do_] = this.dateRange || [];

      if (this.selectedAbsence.status == 999) {
        if (!confirm('Czy na pewno chcesz usunąć ten wniosek urlopowy?')) return;

        try {
          await axios.delete(route('urlopy.destroy', this.selectedAbsence.id));
          this.showToast('success', 'Usunięto', 'Wniosek został usunięty.');
          this.closeModal();
          this.loadData();
        } catch (err) {
          console.error(err);
          this.showToast('error', 'Błąd', 'Nie udało się usunąć wniosku.');
        }

        return;
      }
      this.wolneDni = this.countWorkingDays(this.formatDate(od), this.formatDate(do_));
      try {
        await axios.post(route('urlopy.updatestatus', this.selectedAbsence.id), {
          status: this.selectedAbsence.status,
          urlop_od: this.formatDate(od),
          urlop_do: this.formatDate(do_),
          pracownicy: this.form.delegacjaPracownicy.map(p => p.id),
          wolnedni: this.wolneDni,
        });
        this.showToast('success', 'Zapisano', 'Wniosek został zaktualizowany.');
        this.wolneDni = '';
        this.form.delegacjaPracownicy = [];
        this.closeModal();
        this.loadData();
        this.fetchPendingRequests();
        this.fetchBrakKartki();
      } catch (err) {

        if (err.response && err.response.status === 422 && err.response.data.details) {
          const names = err.response.data.details.join(', ');
          Toast.fire({
            icon: 'error',
            title: 'Konflikt urlopu',
            text: `Kolizja z użytkownikiem: ${names}`,
          });
        } else {
          this.showToast('error', 'Błąd', 'Nie udało się zaktualizować wniosku.');
        }
      }

    },


    async saveReservation2() {
      if (!this.selectedAbsence) return;

      const [start, end] = this.dateRange || [];
      this.wolneDni = this.countWorkingDays(start, end);
      try {
        await axios.put(route('urlopy.updateDelegacja', this.selectedAbsence.id), {
          urlop_od: this.formatDate(start),
          urlop_do: this.formatDate(end),
          pracownicy: this.form.delegacjaPracownicy.map(p => p.id),
          wolnedni: this.wolneDni,
          opis: this.selectedAbsence.opis,
          delegacja_id: this.selectedAbsence.delegacja_id,
        });
        this.showToast('success', 'Zapisano', 'Wniosek został zaktualizowany.');
        this.wolneDni = '';
        this.form.delegacjaPracownicy = [];
        this.closeModal();
        this.loadData();
      } catch (err) {
        if (err.response && err.response.status === 422 && err.response.data.details) {
          const names = err.response.data.details.join(', ');
          Toast.fire({
            icon: 'error',
            title: 'Konflikt delegacji',
            text: `Pracownicy z kolizją: ${names}`,
          });
        } else {
          Toast.fire({
            icon: 'error',
            title: 'Błąd serwera',
            text: 'Nie udało się zapisać delegacji.',
          });
        }
      }
    },

    async accept(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Zatwierdzenie wniosku',
        html: 'Czy na pewno chcesz zatwierdzić wybrany wniosek?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put(route('urlopy.accept', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Wniosek został zatwierdzony',
              });
              this.loadData();
              this.fetchPendingRequests();
              this.fetchBrakKartki();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się zatwierdzić wniosku',
                text: error.response?.data?.message || 'Wystąpił błąd podczas zatwierdzania wniosku',
              });
            });
        }
      });
    },


    async reject(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Odrzucenie wniosku',
        html: 'Czy na pewno chcesz odrzucić wybrany wniosek?',
        showDenyButton: true,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post(route('urlopy.anuluj.user', id))
            .then(response => {
              Toast.fire({
                icon: 'success',
                title: 'Wniosek został odrzucony',
              });
              this.loadData();
              this.fetchPendingRequests();
              this.fetchBrakKartki();
            })
            .catch(error => {
              console.error(error);
              Toast.fire({
                icon: 'error',
                title: 'Nie udało się odrzucić wniosku',
                text: error.response?.data?.message || 'Wystąpił błąd podczas odrzucenia wniosku',
              });
            });
        }
      });
    },

    async createNewUrlop() {
      const [od, do_] = this.newDateRange || [];

      if (!od || !do_ || !this.newUrlop.typ_id) {
        this.showToast('error', 'Błąd', 'Uzupełnij wszystkie pola.');
        return;
      }

      const dniRobocze = this.countWorkingDays(od, do_);
      const typ = this.typyUrlopow.find(t => t.id === this.newUrlop.typ_id);

      if (typ?.wypoczynkowy === 1 && this.wykorzystanychDniWolnych + dniRobocze > this.tenRok) {
        this.showToast('error', 'Błąd', 'Przekroczono limit dni urlopu wypoczynkowego.');
        return;
      }

      try {
        await axios.post(route('urlopy.create'), {
          pracownik_id: this.pracownik_id,
          urlop_od: this.formatDate(od),
          urlop_do: this.formatDate(do_),
          typ_id: this.newUrlop.typ_id,
          opcja_id: this.selectedOption || null,
          status: this.newUrlop.status,
        });
        this.showToast('success', 'Dodano', 'Nowy wniosek o urlop został dodany.');
        this.closeModal();
        this.loadData();
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się dodać wniosku o urlop.');
      }
    },


    onDateRangeChange(args) {
      this.dateRange = args.value;
      if (this.selectedAbsence) {
        this.selectedAbsence.start = this.formatDateForBackend(this.dateRange[0]);
        this.selectedAbsence.end = this.formatDateForBackend(this.dateRange[1]);
      }
    }
    ,
    formatDateForBackend(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    },

    getStatusText(status) {
      switch (status) {
        case 0: return 'Oczekuje';
        case 1: return 'Zatwierdzony';
        case 2: return 'Odrzucony';
        case 3: return 'Anulowany';
        default: return 'Nieznany';
      }
    },

    getPrzepustkaTyp(typ) {
      switch (typ) {
        case 0: return '(z nadgodzin)';
        case 1: return '(z urlopu)';
        default: return '';
      }
    },

    async openModal(clickday, pracownik) {
      this.selectedday = clickday;
      this.pracownik_id = pracownik.id;
      this.pracownik_name = pracownik.name;

      await this.getInfo(clickday, this.pracownik_id);
      if (this.selectedAbsence && this.selectedAbsence.raw_typ_urlopu === 100) {
        await this.getAttachments(this.selectedAbsence.delegacja_id);
      }
      this.isModalOpen = true;
    },

    countWorkingDays(startDate, endDate) {
      let count = 0;
      let current = new Date(startDate);
      const end = new Date(endDate);
      const holidaysCache = {};

      while (current <= end) {
        const day = current.getDay();
        const year = current.getFullYear();

        if (!holidaysCache[year]) {
          holidaysCache[year] = this.getPolishHolidays(year);
        }

        const dateStr = this.formatDate(current);
        const isWeekend = day === 0 || day === 6;
        const isHoliday = holidaysCache[year].includes(dateStr);

        if (!isWeekend && !isHoliday) {
          count++;
        }

        current.setDate(current.getDate() + 1);
      }

      return count;
    },

    async openModalAndLoadInfo(wniosek) {
      const day = new Date(wniosek.start).getDate();
      const user = this.getEmployeeById(wniosek.user_id);

      if (user) {
        this.selectedAbsence = wniosek;
        this.selectedday = day;
        this.pracownik_id = user.id;
        this.pracownik_name = user.name;

        await this.getInfo(day, user.id, true);

        this.isModalOpen = true;
      }
    },

    getEmployeeById(id) {
      return this.users.find(u => u.id === id);
    },

    async getInfo(day, userId, preserveSelectedAbsence = false) {
      const rok = this.selectedYear;
      const miesiac = this.selectedMonth;
      const user_id = userId;
      const dzien = day;

      try {
        const response = await axios.get(route('urlopy.getinfo'), {
          params: { rok, miesiac, user_id, dzien }
        });

        const data = response.data;

        this.wnioskiUrlopowe = Array.isArray(data.urlopy) ? data.urlopy : [];
        this.typyUrlopow = data.typyUrlopow || [];
        this.opcjeUrlopow = data.opcjeUrlopow || {};
        this.tenRok = data.tenRok ?? 0;
        this.poprzedniRok = data.poprzedniRok ?? 0;
        this.wykorzystaneDniWolne = data.wykorzystaneWolne || 0;

        if (!preserveSelectedAbsence) {
          this.selectedAbsence = this.wnioskiUrlopowe.find(urlop => {
            const start = new Date(urlop.start + 'T00:00:00Z');
            const end = new Date(urlop.end + 'T23:59:59Z');
            const currentDate = new Date(Date.UTC(this.selectedYear, this.selectedMonth, day));
            return currentDate >= start && currentDate <= end;
          }) || null;
        }

        this.urlopy = {};
        this.wnioskiUrlopowe.forEach(u => {
          if (!this.urlopy[u.user_id]) this.urlopy[u.user_id] = [];
          this.urlopy[u.user_id].push(u);
        });

      } catch (error) {
        console.error("Błąd podczas pobierania wniosków urlopowych:", error);
      }
    },



    isToday(day) {
      const today = new Date()
      return (
        day === today.getDate() &&
        this.selectedMonth === today.getMonth() &&
        this.selectedYear === today.getFullYear()
      )
    },


    closeModal() {
      this.isModalOpen = false;
    },

    isSunday(day) {
      const date = new Date(this.selectedYear, this.selectedMonth, day);
      return date.getDay() === 0;
    },
    isSaturday(day) {
      const date = new Date(this.selectedYear, this.selectedMonth, day);
      return date.getDay() === 6;
    },
    dzientygodnia(day) {
      const date = new Date(this.selectedYear, this.selectedMonth, day)
      const dayIndex = date.getDay() // 0 = niedziela, 1 = poniedziałek, ...
      const customAbbreviations = ['N', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'S']
      return customAbbreviations[dayIndex]
    },
    getStatusClass(employee, day) {
      const dateKey = `${this.selectedYear}-${String(this.selectedMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
      const status = employee.absences?.[dateKey];

      switch (status) {
        case 'typ100':
          return 'bg-blue';
        case 'typ100_pending':
          return 'bg-orange';
        case 'nieobecny':
          return 'bg-red';
        case 'nieobecny_pending':
          return 'bg-orange';
        case 'przepustka':
          return 'bg-p';
        default:
          return '';
      }
    },
    prevMonth() {
      if (this.selectedMonth === 0) {
        this.selectedMonth = 11;
        this.selectedYear--;
      } else {
        this.selectedMonth--;
      }
    },
    nextMonth() {
      if (this.selectedMonth === 11) {
        this.selectedMonth = 0;
        this.selectedYear++;
      } else {
        this.selectedMonth++;
      }
    },


    async loadData() {
      const updatedUsers = await Promise.all(this.localUsers.map(async user => {

        try {
          const response = await axios.get(route('urlopy.getinfo'), {
            params: {
              rok: this.selectedYear,
              miesiac: this.selectedMonth,
              user_id: user.id,
            }
          });

          const urlopy = Array.isArray(response.data.urlopy) ? response.data.urlopy : [];
          const przepustki = Array.isArray(response.data.przepustki) ? response.data.przepustki : [];
          const absences = {};
          for (const wniosekp of przepustki) {
            const d = new Date(wniosekp.data_wyjscia + 'T00:00:00Z');
            const key = d.toISOString().split('T')[0];

            absences[key] = 'przepustka';
          }
          for (const wniosek of urlopy) {
            const start = new Date(wniosek.start + 'T00:00:00Z');
            const end = new Date(wniosek.end + 'T23:59:59Z');
            let d = new Date(start);

            while (d <= end) {
              const key = d.toISOString().split('T')[0];

              // Zatwierdzone
              if (wniosek.status === 1 && wniosek.typ_id != 25) {
                absences[key] = String(wniosek.typ_id) === '100' ? 'typ100' : 'nieobecny';
              }

              // Oczekujące
              else if (wniosek.status === 0) {
                absences[key] = String(wniosek.typ_id) === '100' ? 'typ100_pending' : 'nieobecny_pending';
              }

              d.setDate(d.getDate() + 1);
            }
          }
          const hasUserData = response.data.hasUserData ?? false;
          const brakWymaganegoUrlopu = response.data.brakWymaganegoUrlopu ?? false;
          return {
            ...user,
            absences,
            hasUserData,
            brakWymaganegoUrlopu,
          };
        } catch (error) {
          console.error(`Błąd przy pobieraniu danych dla user_id=${user.id}:`, error);
          return {
            ...user,
            absences: {},
          };
        }
      }));

      this.localUsers = updatedUsers;
    },



    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: { popup: 'animate__animated animate__fadeInDown' },
        hideClass: { popup: 'animate__animated animate__fadeOutUp' },
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }

  },
  mounted() {
    this.loadData();
    this.fetchPendingRequests();
    this.fetchBrakKartki();
  }
}
</script>

<style scoped>
table th,
table td {
  min-width: 32px;
  height: 32px;
  text-align: center;
}

.bg-red {
  background-color: red;
  color: white;
}

.bg-blue {
  background-color: blue;
  color: white;
}

.bg-orange {
  background-color: orange;
  color: white;
}

.bg-Lightblue {
  background-color: #5fb2d8;
}

.bg-gray-100 {
  background-color: #f5f5f5;
}

.bg-gray-50 {
  background-color: #fafafa;
}

.text-gray {
  color: #9ca3af;
}

.cursor-pointer {
  cursor: pointer;
}

.text-blue {
  color: #3b82f6;
}

.text-white {
  color: white;
}

.bg-p {
  background-color: yellow;
  color: black;
}

.calendar-legend .legend-item div {
  border-radius: 3px;
}

.bg-holiday {
  background-color: #eee3e3 !important;
}
</style>
